



















































































































































































































































































































































































import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import {
  GripperTypeEnum,
  IDialog,
  MachineSettings,
  MultipickConfigurationEnum,
  RobotTypeEnum,
  Settings,
  ConveyorConfigurationEnum, PedestalTypeEnum, ProgramSettings
} from '@/model/index'
import VueCookies from 'vue-cookies'
import ConfirmDialog from '@/components/shared/ConfirmDialog.vue'
import { defaultConveyorInfeedCollection, gripperLengthInterval, gripperWidthInterval, robots } from '@/api/const'
import { mapGetters } from 'vuex'
import Units from '@/api/utils/units'
import LoginDialog from '@/components/LoginDialog.vue'
import {permissions} from '@/userUtils'
import { Conveyor3D } from '@/libs/conveyor3D'
import LabelPositionEnum = ProgramSettings.LabelPositionEnum

Vue.use(VueCookies)

interface GripperType {
  id: GripperTypeEnum,
  title: string,
  width: number,
  length: number,
  sections: number,
  groupingType: string
}

interface PedestalType {
  id: PedestalTypeEnum,
  title: string
}

interface MultipickConfiguration {
  id: MultipickConfigurationEnum,
  title: string
}

@Component({
  components: { LoginDialog: LoginDialog, ConfirmDialog },
  computed: {
    ...mapGetters('settings', [ 'settings' ]),
    ...mapGetters('user', [ 'userPermissions' ])
  }
})
export default class MachineComponent extends Vue {
  @Prop() machinesettings!: MachineSettings
  @Prop() palletPatternsCount!: number
  @Prop() fixedMachineSettings!: boolean

  private settings!: Settings
  private userPermissions!: string[]
  private rules: object = {
    required: (v: any) => !!v || this.localText('general.required'),
    validRange: (v: any) => v === 0 || (v && v >= -1000 && v <= 2000) || this.localText('machineSettings.validRange'),
    validVacuumSections: (v: any) => this.isValidVacuumSections(v) || this.localText('machineSettings.vacuumSectionsRange')
  }
  private valid: boolean = false
  private showConfirmChangeDialog: boolean = false
  private showToolTip: boolean = false
  private confirmChangeDialogProps: IDialog = {
    title: '',
    text: this.localText('machineSettings.gripperChanged'),
    cancelBtn: this.localText('general.cancel'),
    acceptBtn: this.localText('general.confirm')
  }
  private selectedGripper = GripperTypeEnum.STANDARD_1_SECTION
  private selectedPedestalType = PedestalTypeEnum.STANDARD
  private oldGripperValue: GripperTypeEnum | undefined
  private selectedRobotType = RobotTypeEnum.GENERIC
  private oldRobotType = RobotTypeEnum.GENERIC
  private robotChanged: boolean = false
  private selectedGripperSections = 2
  private currentGripperLength = 397
  private currentGripperWidth = 357
  private pusher: boolean = false
  private selectedGroupingType = 'InLine'
  private customConveyorConfig: boolean = false
  private disableDoublePlace: boolean = false
  private freeBoxGrouping: boolean = false
  private numberOfVacuumSections: number = 1
  private vacuumSectionSelectionEnabled: boolean = false
  private selectedMultipickConfiguration = MultipickConfigurationEnum.NONE

  private defaultGripperList: GripperType[] = [
    {id: GripperTypeEnum.STANDARD_1_SECTION, title: 'machineSettings.Gripper1', sections: 1, length: 397, width: 357, groupingType: 'InLine' }
  ]

  private RI20SpecificGrippers: GripperType[] = [
    {id: GripperTypeEnum.STANDARD_2_SECTION_1_GENERATION, title: 'machineSettings.Gripper2', sections: 2, length: 640, width: 400, groupingType: 'InLine' },
    {id: GripperTypeEnum.STANDARD_2_SECTION_2_GENERATION, title: 'machineSettings.Gripper3', sections: 2, length: 540, width: 400, groupingType: 'InLine' },
    {id: GripperTypeEnum.STANDARD_3_INLINE, title: 'machineSettings.Gripper7', sections: 3, length: 510, width: 260, groupingType: 'InLine' },
    // {id: GripperSettings.GripperTypeEnum.STANDARD_QUAD_PICK_4_ZONES, title: 'machineSettings.Gripper4', sections: 4, length: 1, width: 1 }, // under development
    {id: GripperTypeEnum.STANDARD_QUAD_PICK_6_ZONES, title: 'machineSettings.Gripper5', sections: 4, length: 450, width: 360, groupingType: '2x2' }
  ]

  private customGripperList: GripperType[] = [
      {id: GripperTypeEnum.CUSTOM_GRIPPER, title: 'machineSettings.Gripper6', sections: 1, length: 0, width: 0, groupingType: 'InLine' }
  ]

  private newGrippersList: GripperType[] = this.defaultGripperList
  private robotList = robots
  private selectedStandardGripper = GripperTypeEnum.STANDARD_1_SECTION
  private isDisabledField: boolean = false

  // from Basic Setup
  private extendedPedestal: boolean = false
  private additionalPedestalHeight: number = 0
  // from Robot Setup
  private conveyorConfiguration: any = ''
  private conveyorInfeedCollection: any[] = [defaultConveyorInfeedCollection [0]] // default left only
  private approachAngle = 45
  private view!: Conveyor3D
  private isReady: boolean = false

  private pedestalTypes: PedestalType[] = [
    {id: PedestalTypeEnum.STANDARD, title: 'machineSettings.standard'},
    {id: PedestalTypeEnum.EXTENDED, title: 'machineSettings.extended'},
    {id: PedestalTypeEnum.ELECTRICAL, title: 'machineSettings.electrical'}
  ]
  private multipickConfigurationList: MultipickConfiguration[] = [
    {id: MultipickConfigurationEnum.NONE, title: 'machineSettings.none'},
    {id: MultipickConfigurationEnum.INLINE_CENTERED, title: 'machineSettings.multipickInlineCentered'},
    {id: MultipickConfigurationEnum.INLINE_EDGE_ALIGNED, title: 'machineSettings.multipickInlineEdgeAligned'}
  ]
  private lowPedestalHeight: number = 0
  private highPedestalHeight: number = 0
  private electricalPedestalThreshold: number = 0

  created() {
    this.isDisabledField = this.userPermissions.includes(permissions.MODIFYGRIPPERMACHINESETTINGS)
    this.setInitialSettingsValues()
  }

  mounted() {
    const afterCreated = () => {
      // console.log('[DEBUG] afterCreated handler')
      this.view.setCustom(this.isCustomSolution())
      this.view.setPosition(this.conveyorConfiguration)
      this.view.moveScene(this.conveyorConfiguration, LabelPositionEnum.FRONT)
      this.isReady = true
    }

    setTimeout(() => {
      this.updateConveyorConfig()
      this.view = new Conveyor3D('conveyor3d', ConveyorConfigurationEnum.LEFT, afterCreated, {h: 200, w: 550})
    }, 100)
  }

  private isCustomGripper() {
    return this.selectedGripper && this.selectedGripper === GripperTypeEnum.CUSTOM_GRIPPER
  }

  private isGenericJSON() {
    return this.selectedRobotType === RobotTypeEnum.GENERIC
  }

  private isRC10UR() {
    return this.selectedRobotType === RobotTypeEnum.RC10_UR
  }

  private isRC12() {
    return this.selectedRobotType === RobotTypeEnum.RC12
  }

  private isRC20() {
    return this.selectedRobotType === RobotTypeEnum.RC20
  }

  private isRI20() {
    return this.selectedRobotType === RobotTypeEnum.RI20_FANUC || this.selectedRobotType === RobotTypeEnum.RI20_KUKA
  }

  private isCustomSolution() {
    return this.selectedRobotType === RobotTypeEnum.CUSTOM_SOLUTION
  }

  private isFreeBoxGroupingSupported() {
    return this.isGenericJSON()
  }

  private showMultipickConfiguration() {
    return this.isCustomGripper() && (this.isRC12() || this.isRC20())
  }

  private isPusherSupported() {
    return this.isRI20()
  }

  private localText (arg: string): string {
    return String(this.$t(arg))
  }

  private checkLength (v: number) {
    return this.checkGripperRange(v, gripperLengthInterval)
  }

  private checkWidth (v: number) {
    return this.checkGripperRange(v, gripperWidthInterval)
  }

  private checkGripperRange (v: number, interval: { min: number, max: number }) {
    const max = interval.max
    const min = this.showMultipickConfiguration() ? 1 : interval.min
    if (v < min! || v > max!) {
      return `${this.localText('boxStep.errVal')} ${min} - ${max} ${this.units.localLengthUnit}`
    }
    return true
  }

  private isValidVacuumSections (value: any): boolean {
    const sections = Number(value)
    return Number.isInteger(sections) && sections >= 1 && sections <= 10
  }

  private getVacuumSectionsValue (value: any): number {
    const sections = Number(value)
    if (!Number.isFinite(sections)) {
      return 1
    }
    return Math.min(10, Math.max(1, Math.floor(sections)))
  }

  private normalizeVacuumSectionsInput () {
    this.numberOfVacuumSections = this.getVacuumSectionsValue(this.numberOfVacuumSections)
  }

  private setInitialSettingsValues() {
    this.selectedRobotType = this.machinesettings.robotType!
    this.oldRobotType = this.selectedRobotType

    // gripper settings
    this.initCustomGripperList(this.machinesettings)
    this.setNewGripperList()
    this.selectedGripper = this.machinesettings.gripperSettings!.gripperType! || this.defaultGripperList[0].id
    this.oldGripperValue = this.selectedGripper
    this.selectedMultipickConfiguration = this.machinesettings.gripperSettings!.multipickConfiguration || MultipickConfigurationEnum.NONE
    const nonStandardGripper = !this.machinesettings.gripperSettings  || !this.machinesettings.gripperSettings.gripperSections
        || !this.RI20SpecificGrippers.find(p => p.sections === this.machinesettings.gripperSettings!.gripperSections)
    this.selectedStandardGripper = (nonStandardGripper) ? this.defaultGripperList[0].id : this.RI20SpecificGrippers.find(p => p.sections === this.machinesettings.gripperSettings!.gripperSections)!.id
    this.setGripperValues(this.selectedGripper)

    this.pusher = this.machinesettings.pusher!
    this.customConveyorConfig = this.machinesettings.customConveyorConfig !== undefined && this.machinesettings.customConveyorConfig.length > 0
    this.disableDoublePlace = (this.machinesettings.disableDoublePlace === undefined) ? this.showDoublePlaceOption() : this.machinesettings.disableDoublePlace
    this.extendedPedestal = (this.machinesettings.additionalPedestalHeight != null &&
        this.machinesettings.additionalPedestalHeight! > 0) ||
        this.machinesettings.pedestalType === PedestalTypeEnum.EXTENDED
    this.additionalPedestalHeight = this.machinesettings.additionalPedestalHeight || 0
    const angle = this.machinesettings.approachAngle
    this.approachAngle = angle === 0 || angle ? Number(angle) : 45
    this.conveyorConfiguration = this.machinesettings.conveyorConfiguration || this.getDefaultConveyorConfig()
    this.selectedPedestalType = this.machinesettings.pedestalType! ? this.machinesettings.pedestalType! :
        (this.extendedPedestal ? PedestalTypeEnum.EXTENDED : PedestalTypeEnum.STANDARD )
    this.lowPedestalHeight = this.machinesettings.lowPedestalHeight!
    this.highPedestalHeight = this.machinesettings.highPedestalHeight!
    this.electricalPedestalThreshold = this.machinesettings.electricalPedestalThreshold!
    this.freeBoxGrouping = this.isFreeBoxGroupingSupported() &&
        this.machinesettings.customSettings !== undefined && this.machinesettings.customSettings.freeBoxGrouping!
    this.numberOfVacuumSections = this.getVacuumSectionsValue(this.machinesettings.numberOfVacuumSections)
    this.vacuumSectionSelectionEnabled = this.machinesettings.vacuumSectionSelectionEnabled === true
  }

  private initCustomGripperList (machineSettings: MachineSettings) {
    const isCustom = (GripperTypeEnum.CUSTOM_GRIPPER === machineSettings.gripperSettings!.gripperType)
    this.customGripperList[0].length = (isCustom) ? machineSettings.gripperSettings!.gripperLength! : this.defaultGripperList[0].length
    this.customGripperList[0].width = (isCustom) ? machineSettings.gripperSettings!.gripperWidth! : this.defaultGripperList[0].width
    this.customGripperList[0].sections = (isCustom) ? machineSettings.gripperSettings!.gripperSections! : this.defaultGripperList[0].sections
  }

  private getDefaultHighPedestalHeight(): number {
    if (this.selectedPedestalType === PedestalTypeEnum.STANDARD || this.selectedPedestalType === PedestalTypeEnum.EXTENDED) {
      return 0
    }
    return (this.isRC12() || this.isRC20()) ? 484 : 0
  }

  private getDefaultElectricalPedestalThreshold(): number {
    if (this.selectedPedestalType === PedestalTypeEnum.STANDARD || this.selectedPedestalType === PedestalTypeEnum.EXTENDED) {
      return 0
    }
    return (this.isRC12() || this.isRC20()) ? 1200 : 0
  }

  private showCustomConveyorOption() {
    return this.selectedRobotType === RobotTypeEnum.RI20_FANUC
  }

  private showDoublePlaceOption() {
    return this.isRI20()
        && this.selectedGripper != null
        && (this.selectedGripper === GripperTypeEnum.STANDARD_2_SECTION_1_GENERATION
            || this.selectedGripper === GripperTypeEnum.STANDARD_2_SECTION_2_GENERATION
            || this.selectedGripperSections === 2)
  }

  private showConfirmDialog (gripper: GripperTypeEnum) {
    this.selectedGripper = gripper
    this.showConfirmChangeDialog = this.selectedGripper !== this.oldGripperValue && this.palletPatternsCount > 0
    if (this.palletPatternsCount <= 0) {
      this.updateGripper()
    }
  }

  private cancelUpdateGripper() {
    if (this.robotChanged) {
      this.selectedRobotType = this.oldRobotType
      this.setNewGripperList()
      this.robotChanged = false
    }
    if (this.oldGripperValue != null) {
      this.setGripperValues(this.oldGripperValue)
    }
    this.showConfirmChangeDialog = false
  }

  private updateGripper () {
    if (this.robotChanged) {
      this.setNewGripperList()
      this.oldRobotType = this.selectedRobotType
      this.robotChanged = false
    }
    this.oldGripperValue = this.selectedGripper
    this.setGripperValues(this.selectedGripper!)
    this.disableDoublePlace = this.showDoublePlaceOption()
    if (this.showConfirmChangeDialog) {
      this.showConfirmChangeDialog = false
    }
  }

  private setGripperValues(gripperTypeEnum: GripperTypeEnum) {
    const gripperType = this.newGrippersList.find(g => g.id === gripperTypeEnum)
    // console.log('MachineComponent - setGripperValues - gripperType', gripperTypeEnum, JSON.stringify(gripperType), JSON.stringify(this.selectedGripper))
    this.selectedGripper = (gripperType) ? gripperTypeEnum : this.newGrippersList[0].id

    const isCustom = this.isCustomGripper()
    let customBaseGripper = this.RI20SpecificGrippers.find(g => g.id === this.selectedStandardGripper) || this.defaultGripperList[0]
    if (this.isCustomSolution() || (isCustom && customBaseGripper.sections === gripperType!.sections)) {
      customBaseGripper = gripperType! // avoid dimension override for custom gripper
    }
    this.selectedGripperSections = isCustom ? customBaseGripper.sections : gripperType!.sections
    this.currentGripperLength = isCustom ? customBaseGripper.length : gripperType!.length
    this.currentGripperWidth = isCustom ? customBaseGripper.width : gripperType!.width
    this.selectedGroupingType = isCustom ? customBaseGripper.groupingType : gripperType!.groupingType
    if (!this.showMultipickConfiguration()) {
      this.selectedMultipickConfiguration = MultipickConfigurationEnum.NONE
    }
  }

  private setCustomGripperValues(gripperTypeEnum: GripperTypeEnum) {
    const gripperType = this.newGrippersList.find(g => g.id === gripperTypeEnum)
    this.currentGripperWidth = gripperType!.width
    this.currentGripperLength = gripperType!.length
    this.selectedGripperSections = gripperType!.sections
    this.selectedGroupingType = gripperType!.groupingType
  }

  private gripperItems(): GripperType[] {
    this.setNewGripperList()
    return this.newGrippersList.map(p => ({ title: this.$t(p.title), id: p.id } as GripperType))
  }

  private setNewGripperList() {
    if (this.isCustomSolution()) {
      this.newGrippersList = this.customGripperList
      return
    }

    if (this.isRI20()) {
      if (!this.newGrippersList.some(p => p.id === GripperTypeEnum.CUSTOM_GRIPPER) || this.newGrippersList.length === 1 || this.newGrippersList.length === 2) {
        this.newGrippersList = [...this.defaultGripperList, ...this.RI20SpecificGrippers, ...this.customGripperList]
      }
      return
    }

    if (!this.isRC12() && !this.isRC20()) {
      this.newGrippersList = this.defaultGripperList
      return
    }

    if (!this.newGrippersList.some(p => p.id === GripperTypeEnum.CUSTOM_GRIPPER) || this.newGrippersList.length !== 2) {
      this.newGrippersList = [...this.defaultGripperList, ...this.customGripperList]
    }
  }

  private standardGripperItems(): GripperType[] {
    if (this.isRI20() && this.selectedGripper === GripperTypeEnum.CUSTOM_GRIPPER) {
      return [...this.defaultGripperList, ...this.RI20SpecificGrippers].map(p => ({ title: this.$t(p.title), id: p.id } as GripperType))
    }
    return this.defaultGripperList.map(p => ({ title: this.$t(p.title), id: p.id } as GripperType))
  }

  private multipickConfigurationItems(): MultipickConfiguration[] {
    return this.multipickConfigurationList.map(p => ({ title: this.$t(p.title), id: p.id } as MultipickConfiguration))
  }

  private gripperGroupTypes(): string[] {
    return this.newGrippersList.map(p => p.groupingType!)
  }

  private updateRobotType(robotType: RobotTypeEnum) {
    this.robotChanged = true
    // Standard 1 Section is default gripper for all robots but custom solution
    const defaultGripperForRobot = (this.isCustomSolution()) ? this.customGripperList[0].id : this.defaultGripperList[0].id
    this.showConfirmDialog(defaultGripperForRobot)
    this.changePedestalType()
  }

  private cancel () {
    this.$emit('cancel')
  }

  private save () {
    this.machinesettings.robotType = this.selectedRobotType
    this.machinesettings.gripperSettings = {
      gripperType: this.selectedGripper,
      gripperWidth: this.currentGripperWidth,
      gripperLength: this.currentGripperLength,
      gripperSections: this.selectedGripperSections,
      groupingType: this.selectedGroupingType,
      ...(this.showMultipickConfiguration() ? { multipickConfiguration: this.selectedMultipickConfiguration } : {})
    }
    this.machinesettings.pusher = (this.isPusherSupported()) ? this.pusher : false
    this.machinesettings.customConveyorConfig = (this.customConveyorConfig && this.showCustomConveyorOption()) ? [1, 2, 3, 4] : []
    this.machinesettings.disableDoublePlace = (this.disableDoublePlace && this.showDoublePlaceOption()) ? this.disableDoublePlace : false
    this.machinesettings.additionalPedestalHeight = this.additionalPedestalHeight
    this.machinesettings.approachAngle = this.approachAngle
    this.machinesettings.conveyorConfiguration = this.conveyorConfiguration
    this.machinesettings.pedestalType = this.selectedPedestalType
    this.machinesettings.highPedestalHeight = this.highPedestalHeight
    this.machinesettings.lowPedestalHeight = this.lowPedestalHeight
    this.machinesettings.electricalPedestalThreshold = this.electricalPedestalThreshold
    this.machinesettings.numberOfVacuumSections =
        (this.isCustomSolution() && this.vacuumSectionSelectionEnabled) ? this.getVacuumSectionsValue(this.numberOfVacuumSections) : undefined
    this.machinesettings.vacuumSectionSelectionEnabled = this.isCustomSolution() ? this.vacuumSectionSelectionEnabled : undefined
    this.machinesettings.customSettings = this.isFreeBoxGroupingSupported() ? { freeBoxGrouping: this.freeBoxGrouping } : undefined
    this.$emit('save', this.machinesettings, this.fixedMachineSettings)
  }

  get units () {
    return new Units(this.settings.units || Settings.UnitsEnum.METRIC)
  }

  private getPedestalTypes(): PedestalType[] {
    return this.pedestalTypes.map(p => ({ title: this.$t(p.title), id: p.id } as PedestalType))
  }

  private isExtenderPedestal(): boolean {
    return this.selectedPedestalType === PedestalTypeEnum.EXTENDED
  }

  private isElectricalPedestal(): boolean {
    return this.selectedPedestalType === PedestalTypeEnum.ELECTRICAL
  }

  @Watch('valid')
  private validWatcher (value: boolean) {
    this.$emit('validate', value)
  }

  @Watch('extendedPedestal')
  private extendedPedestalWatcher(newValue: boolean) {
    if (newValue) {
      // extended pedestal changed from false to true. set additional pedestal height to default for selected robot type (only if robot changed)
      if (this.robotChanged || this.additionalPedestalHeight === 0) {
        this.additionalPedestalHeight = this.getDefaultAdditionalPedestalHeight()
      }
    } else {
      // extended pedestal changed from true to false. set additional pedestal height to zero.
      this.additionalPedestalHeight = 0
    }
  }

  get additionalPedestalHeightDisplayValue (): number | undefined {
    return this.units.toLocalLength(this.additionalPedestalHeight)
  }

  set additionalPedestalHeightDisplayValue (newHeight: number | undefined) {
    this.additionalPedestalHeight = this.units.toSystemLength(newHeight)
  }

  get lowPedestalHeightDisplayValue (): number | undefined {
    return this.units.toLocalLength(this.lowPedestalHeight)
  }

  set lowPedestalHeightDisplayValue (newValue: number | undefined) {
    this.lowPedestalHeight = this.units.toSystemLength(newValue)
  }

  get highPedestalHeightDisplayValue (): number | undefined {
    return this.units.toLocalLength(this.highPedestalHeight)
  }

  set highPedestalHeightDisplayValue (newValue: number | undefined) {
    this.highPedestalHeight = this.units.toSystemLength(newValue)
  }

  get electricalPedestalThresholdDisplayValue (): number | undefined {
    return this.units.toLocalLength(this.electricalPedestalThreshold)
  }

  set electricalPedestalThresholdDisplayValue (newValue: number | undefined) {
    this.electricalPedestalThreshold = this.units.toSystemLength(newValue)
  }

  private changePedestalType() {
    if (this.selectedPedestalType === PedestalTypeEnum.STANDARD) {
      this.additionalPedestalHeight = 0
      this.lowPedestalHeight = 0
      this.highPedestalHeight = 0
      this.electricalPedestalThreshold = 0
    }

    if (this.selectedPedestalType === PedestalTypeEnum.EXTENDED) {
      if (this.robotChanged || this.additionalPedestalHeight === 0) {
        this.additionalPedestalHeight = this.getDefaultAdditionalPedestalHeight()
      }
      this.lowPedestalHeight = 0
      this.highPedestalHeight = 0
      this.electricalPedestalThreshold = 0
    }

    if (this.selectedPedestalType === PedestalTypeEnum.ELECTRICAL) {
      this.lowPedestalHeight = 0
      this.highPedestalHeight = this.getDefaultHighPedestalHeight()
      this.electricalPedestalThreshold = this.getDefaultElectricalPedestalThreshold()
      this.additionalPedestalHeight = 0
    }
  }

  private getDefaultAdditionalPedestalHeight (): number {
    // set default values for additionalPedestalHeight
    if (this.isRC10UR()) {
      return 700
    } else if (this.isRI20()) {
      return 280
    }
    return 0
  }

  private translateUnit (unit: string): string {
    return String(this.$t('general.' + unit))
  }

  private changeConveyorView (value: ConveyorConfigurationEnum) {
    // console.log('[DEBUG] Select conveyor infeed: change', value)
    if (!this.isReady) {
      return
    }
    this.conveyorConfiguration = value
    this.view.setPosition(this.conveyorConfiguration)
  }

  private setInfeedCollection () {
    const robot = robots.find(p => p.id === this.selectedRobotType)
    if (robot) {
      let infeeds = robot.infeeds
      if (robot.id === RobotTypeEnum.RI20_FANUC && this.customConveyorConfig) {
        infeeds = [1, 2, 3, 4]
      }
      this.conveyorInfeedCollection = defaultConveyorInfeedCollection.filter(p => infeeds.includes(p.id))
    }
  }

  private getDefaultConveyorConfig() {
    if (this.isRI20()) {
      return ConveyorConfigurationEnum.CENTER_LEFT
    }
    return ConveyorConfigurationEnum.LEFT
  }

  private populateConveyor () {
    const v = this.conveyorConfiguration
    const index = this.conveyorInfeedCollection.findIndex(c => c.value === v)
    if (index > -1) {
      this.conveyorConfiguration = v
    } else {
      this.conveyorConfiguration = this.getDefaultConveyorConfig()
    }
  }

  private updateConveyorConfig() {
    this.setInfeedCollection()
    this.populateConveyor()
    if (this.isReady) {
      this.view.setCustom(this.isCustomSolution())
      this.view.moveScene(this.conveyorConfiguration, LabelPositionEnum.FRONT)
      this.view.setPosition(this.conveyorConfiguration)
    }
  }

  @Watch('selectedRobotType')
  private robotTypeWatcher(value: RobotTypeEnum) {
    this.updateConveyorConfig()
  }
}
